import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import InputAdornment from '@mui/material/InputAdornment';

import { SearchIcon } from '../../../components/customStyles/images';
import { TextFieldWhite } from '../../../components/customStyles/form';

import { PAGE } from '../../../constants/url';

import theme from '../../../theme';


const SelectProduct = (props) => {
  const { selectedProduct, setSelectedProduct, searchKeyword, setSearchKeyword, handelSearchActive, handelSearchKeyDown } = props;
  const navigate = useNavigate();

  const handleProductSelection = () => {
    navigate(PAGE.marketingword.path, { state: selectedProduct });
  }

  const handleClearSelection = () => {
    setSelectedProduct(null);
  }

  const handleSearchInput = (e) => {
    setSearchKeyword(e.target.value);
  }

  return (
    <>
      <Stack variant='between-center'>
        <Stack variant="start-center" mb={1}>
          <Typography
            variant="h5"
            mr={2}
            color={theme.palette.grey.w600}
            sx={{ display: { md: 'none', lg: 'block' } }}
          >
            搜尋
          </Typography>

          <Box>
            <TextFieldWhite
              id="search"
              placeholder="輸入商品關鍵字"
              value={searchKeyword}
              onChange={handleSearchInput}
              onKeyDown={handelSearchKeyDown}
              endAdornment={
                <InputAdornment
                  position="end"
                  sx={{
                    paddingRight: 1,
                    '&:hover': { color: theme.palette.primary.main }
                  }}
                >
                  <SearchIcon onClick={handelSearchActive} />
                </InputAdornment>
              }
              sx={{ cursor: 'pointer', width: '360px' }}
            />
          </Box>
        </Stack>

        <Stack spacing={1}>
          <Button
            variant='fill-red'
            disabled={!selectedProduct ? true : false}
            onClick={handleProductSelection}
          >
            確認選取商品
          </Button>
          <Button
            variant='outlined-grey'
            disabled={!selectedProduct ? true : false}
            onClick={handleClearSelection}
          >
            清除選取
          </Button>
        </Stack>
      </Stack>
    </>
  )
}

export default SelectProduct;